// import Vue from 'vue'
// import Vuex from 'vuex'
Vue.use(Vuex)
import news from "./modules/news";
import rectify from "./modules/rectify";
import training from "./modules/training";

const store = new Vuex.Store({
  modules: { rectify, training, news },
  state: {
    topicIdData: []
  },
  mutations: {


  }
})

export default store
